export default __webpack_public_path__ + "static/media/Project-1-Cuckoos-Library.a5c78228.JPG";